// =====================================================
// 📁 quotationHistoryFilterUtils.ts
// =====================================================

export const buildQuotationHistoryFilterPayload = (
    filters: any
) => {

    return {

        quotationNumber:
            filters.quotationNumber || null,

        customerId:
            filters.customerId || null,

        sellerId:
            filters.sellerId || null,

        status:
            filters.status || null,

        quotationDate:
            filters.quotationDate || null,

        total:
            filters.total || null,

    };

};